<div *ngIf="(vm$ | async) as vm">

    <mdb-card class="mb-3" cascade="true" narrower="true" *ngIf="!vm.workingText && !vm.errorText" style="height: 5rem">
        <mdb-card-body cascade="true" class="py-2">
            <div class="row mt-n4">
                <!-- left side -->
                <div class="col-md-8 mr-0">
                </div>

                <!-- right side -->
                <div class="col-md-4 mt-1 mb-0">
                    <!-- Search form -->
                    <div class="form-inline md-form form-sm">
                        <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                        <input class="form-control form-control-sm ml-5 w-75" type="search" [ngModel]="searchData"
                            (ngModelChange)="doSearch(vm, $event)" placeholder="Search text">
                    </div>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>

    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <div *ngIf="!vm.workingText && !vm.errorText">

        <div class="row mb-3" *ngFor="let g of vm.groupsFiltered">
            <div class="container-fluid">
                <div class="card card-cascade narrower">
                    <mdb-card>
                        <mdb-body>
                            <div class="row">
                                <div class="col-xl-3 col-md-12 col-lg-12 mr-0">
                                    <div class="view view-cascade gradient-card-header blue-gradient py-2">
                                        <h2 class="h3-responsive card-title font-weight-bold mb-0">{{g.title}}</h2>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-md-12 col-lg-12 mr-0">
                                    <div class="card-body card-body-cascade">
                                        <div class="row">
                                            <div class="col-md-2" *ngFor="let i of g.items"
                                                class="report-item py-1 px-1">
                                                <button (click)="itemClicked(i)" type="button"
                                                    class="btn btn-outline-primary  btn-sm waves-effect btn-block">{{i.title}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mdb-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>

</div>